import type { IPermission, IPermissionExternal, IRoleGroup } from '@/types/Data'
import type { IGetRoleGroupList, ISavePermission } from '@/types/Request'
import BaseService from '../BaseService'

export default class RoleServices extends BaseService {
  GetPermissionByJwt() {
    return this.GET<IPermission[]>(this.PATHS.GET_PERMISSION_BY_JWT, { Prefix: 'admin' })
  }

  GetRoleGroupList(payload: IGetRoleGroupList) {
    return this.GET<IRoleGroup[]>(this.PATHS.GET_ROLE_GROUP_LIST, payload)
  }

  GetPermissionList(RoleGroupId: string) {
    return this.GET<IPermissionExternal[]>(this.PATHS.GET_PERMISSION_LIST, { RoleGroupId })
  }

  SetPermission(data: ISavePermission) {
    return this.POST<void>(this.PATHS.SET_PERMISSION, data)
  }
}
